import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import Placeholder from '../Placeholder/index.js';
import Typography from '../Typography/index.js';
import { Section, BackgroundImage, MobileBackgroundImage, SplitContentGrid, Image } from './SplitContent.styles.js';

var _excluded = ["alignMainContent", "alignImageToBottom", "splitBackgroundColor", "backgroundColor", "backgroundImage", "bottomPadding", "children", "hideImageOnMobile", "borderRadius", "aspectRatio", "customPosition", "image", "imageWidth", "mainContent", "mobileAlignImageToBottom", "mobileBackgroundImage", "mobileImage", "mobileTextColor", "reverseForMobile", "textColor", "topPadding", "width"];
var SplitContent = function SplitContent(_ref) {
  var _ref$alignMainContent = _ref.alignMainContent,
    alignMainContent = _ref$alignMainContent === void 0 ? 'Center' : _ref$alignMainContent,
    _ref$alignImageToBott = _ref.alignImageToBottom,
    alignImageToBottom = _ref$alignImageToBott === void 0 ? false : _ref$alignImageToBott,
    _ref$splitBackgroundC = _ref.splitBackgroundColor,
    splitBackgroundColor = _ref$splitBackgroundC === void 0 ? null : _ref$splitBackgroundC,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? null : _ref$backgroundColor,
    _ref$backgroundImage = _ref.backgroundImage,
    backgroundImage = _ref$backgroundImage === void 0 ? null : _ref$backgroundImage,
    _ref$bottomPadding = _ref.bottomPadding,
    bottomPadding = _ref$bottomPadding === void 0 ? null : _ref$bottomPadding,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$hideImageOnMobil = _ref.hideImageOnMobile,
    hideImageOnMobile = _ref$hideImageOnMobil === void 0 ? false : _ref$hideImageOnMobil,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? null : _ref$borderRadius,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? null : _ref$aspectRatio,
    _ref$customPosition = _ref.customPosition,
    customPosition = _ref$customPosition === void 0 ? null : _ref$customPosition,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$imageWidth = _ref.imageWidth,
    imageWidth = _ref$imageWidth === void 0 ? null : _ref$imageWidth,
    _ref$mainContent = _ref.mainContent,
    mainContent = _ref$mainContent === void 0 ? null : _ref$mainContent,
    _ref$mobileAlignImage = _ref.mobileAlignImageToBottom,
    mobileAlignImageToBottom = _ref$mobileAlignImage === void 0 ? false : _ref$mobileAlignImage,
    _ref$mobileBackground = _ref.mobileBackgroundImage,
    mobileBackgroundImage = _ref$mobileBackground === void 0 ? null : _ref$mobileBackground,
    _ref$mobileImage = _ref.mobileImage,
    mobileImage = _ref$mobileImage === void 0 ? null : _ref$mobileImage,
    _ref$mobileTextColor = _ref.mobileTextColor,
    mobileTextColor = _ref$mobileTextColor === void 0 ? null : _ref$mobileTextColor,
    _ref$reverseForMobile = _ref.reverseForMobile,
    reverseForMobile = _ref$reverseForMobile === void 0 ? false : _ref$reverseForMobile,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? null : _ref$textColor,
    _ref$topPadding = _ref.topPadding,
    topPadding = _ref$topPadding === void 0 ? null : _ref$topPadding,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? null : _ref$width,
    props = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // TODO: [LC-314] remove className from root element and use data-attribute
    React.createElement(Section, _extends({
      className: "leshen-split-content background-color-".concat(backgroundColor || 'default'),
      splitBackgroundColor: splitBackgroundColor,
      hideImageOnMobile: hideImageOnMobile,
      alignMainContent: alignMainContent,
      alignImageToBottom: alignImageToBottom,
      mobileAlignImageToBottom: mobileAlignImageToBottom,
      imageWidth: imageWidth,
      mobileImage: mobileImage,
      reverseForMobile: reverseForMobile,
      backgroundColor: backgroundColor,
      textColor: textColor,
      mobileTextColor: mobileTextColor,
      topPadding: topPadding,
      bottomPadding: bottomPadding,
      width: width
    }, props), backgroundImage && /*#__PURE__*/React.createElement(BackgroundImage, {
      mobileBackgroundImage: mobileBackgroundImage
    }, backgroundImage), mobileBackgroundImage && /*#__PURE__*/React.createElement(MobileBackgroundImage, null, mobileBackgroundImage), /*#__PURE__*/React.createElement(SplitContentGrid, {
      className: "split-content__grid",
      backgroundColor: backgroundColor,
      hasBackgroundImage: Boolean(backgroundImage)
    }, /*#__PURE__*/React.createElement(Image, {
      borderRadius: borderRadius,
      aspectRatio: aspectRatio,
      customPosition: customPosition,
      className: "split-content__image",
      mobileImage: mobileImage
    }, image || mobileImage ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "mobile-image"
    }, mobileImage), /*#__PURE__*/React.createElement("span", {
      className: "desktop-image"
    }, image)) : /*#__PURE__*/React.createElement(Placeholder, {
      type: "error"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "small"
    }, "Notice"), /*#__PURE__*/React.createElement(Typography, null, "The content entry of type \"SplitContent\" is missing the Image media asset."))), /*#__PURE__*/React.createElement("div", {
      className: "split-content__content"
    }, mainContent, children)))
  );
};
var SplitContent$1 = SplitContent;

export { SplitContent$1 as default };
//# sourceMappingURL=index.js.map
